/**
 * @deprecated
 * The usage library now requires a new structure of namespaces for events. If you need to reference the namespace,
 * please use the new structure also exposed in this file.
 */

export const CRM = 'crm';
/**
 * @deprecated
 * The usage library now requires a new structure of namespaces for events. If you need to reference the namespace,
 * please use the new structure also exposed in this file.
 */

export const COMMUNICATOR = 'communicator';
/**
 * @deprecated
 * The usage library now requires a new structure of namespaces for events. If you need to reference the namespace,
 * please use the new structure also exposed in this file.
 */

export const SETTINGS = 'settingsui';
/**
 * @deprecated
 * The usage library now requires a new structure of namespaces for events. If you need to reference the namespace,
 * please use the new structure also exposed in this file.
 */

export const LISTS = 'lists';
/**
 * @deprecated
 * The usage library now requires a new structure of namespaces for events. If you need to reference the namespace,
 * please use the new structure also exposed in this file.
 */

export const PRODUCTS = 'products';
/**
 * @deprecated
 * The usage library now requires a new structure of namespaces for events. If you need to reference the namespace,
 * please use the new structure also exposed in this file.
 */

export const LINEITEMS = 'line-items';
/**
 * @deprecated
 * The usage library now requires a new structure of namespaces for events. If you need to reference the namespace,
 * please use the new structure also exposed in this file.
 */

export const REPORTING = 'reporting';
/**
 * @deprecated
 * The usage library now requires a new structure of namespaces for events. If you need to reference the namespace,
 * please use the new structure also exposed in this file.
 */
export const TASKS = 'tasks';
export const CRM_TRACKER_NAMESPACE = 'Crm';
export const SETTINGS_TRACKER_NAMESPACE = 'Settingsui';
export const LISTS_TRACKER_NAMESPACE = 'Lists';
export const TASKS_TRACKER_NAMESPACE = 'Tasks';
export const PLAYBOOKS_TRACKER_NAMESPACE = 'Playbooks Admin UI';
export const COMMUNICATOR_TRACKER_NAMESPACE = 'Communicator';
export const LINE_ITEMS_TRACKER_NAMESPACE = 'Line Items';
export const PRODUCTS_TRACKER_NAMESPACE = 'Products';
export const REPORTING_TRACKER_NAMESPACE = 'Reporting';
export const COMMERCE_SUBSCRIPTION_TRACKER_NAMESPACE = 'Commerce Subscription';